import instance from "api/instance";

const get = async () => {
  const response = await instance.get("/admin/bank-balances");
  if (response.status === 200) {
    return response.data;
  }

  return Promise.reject(response.data);
};

const bankBalancesService = {
  get
};

export default bankBalancesService; 